import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

/**
 * Checks is a url contains any facet info.  If a user has chosen a facet it will
 * be added to the URL like this.
 *
 * https://www.drhorton.com/texas/austin#f:Bathrooms=[3]
 *
 * @param url - The url to check for facet info.
 * @returns Returns true if any facet information is found in the url.
 */
export const urlHasFacetInfo = (url: string): boolean => {
	if (isStringEmpty(url)) {
		return false;
	}

	return url.indexOf("f:") !== -1;
};
